import React from 'react';
import PropTypes from 'prop-types';
import {formatHours} from 'components/dashboard/coaching-effectiveness/common';
import './FeedbacksHoursListenedTooltip.styl';
import {ScorecardIcon} from '@components/icon/ScorecardIcon';
import {CommentIcon} from '@components/icon/CommentIcon';
import {EditIcon} from '@components/icon/EditIcon';

export default class FeedbacksHoursListenedTooltip extends React.PureComponent {
  render() {
    const {scoredCount, commentsCount, highlightsCount, hoursListened, owner} = this.props;
    const hours = hoursListened === 1 ? 'hour' : 'hours';
    return (
      <div className="hours-listened-tooltip">
        <div className="title">{owner}'s Feedback vs Time Listening</div>
        <div className="body">
          <div className="listens">
            Total Listening: {formatHours(hoursListened)} {hours}
          </div>
          <div className="counts">
            <div className="row comments">
              <CommentIcon /> Comments: {commentsCount}
            </div>
            <div className="row highlights">
              <EditIcon />
              Highlights: {highlightsCount}
            </div>
            <div className="row scorecards">
              <ScorecardIcon /> Scorecards: {scoredCount}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FeedbacksHoursListenedTooltip.propTypes = {
  scoredCount: PropTypes.number,
  commentsCount: PropTypes.number,
  highlightsCount: PropTypes.number,
  hoursListened: PropTypes.number,
  owner: PropTypes.string,
};
